import ShortAnswer from './model';
import create from './create';

ShortAnswer.create = create;

export default ShortAnswer;



// WEBPACK FOOTER //
// ./data/WritingAssignment/ShortAnswer/model/index.js